const shareColorScope = {
    30: [ 1, 10, 30, 50, 70, 90 ],
    7: [ 1, 10, 30, 50, 70, 90 ],
    1: [ 1, 10, 30, 50, 70, 90 ],
};
const absColorScope = {
    30: [ 5, 100, 250, 500, 750, 1000 ],
    7: [ 2, 10, 50, 100, 250, 500 ],
    1: [ 1, 5, 10, 25, 50, 70 ],
};
const leadershipColorScope = {
    30: [ 'orange', 20 ],
    7: [ 'yellow', 10 ],
    1: [ 'purple', 5 ],
};

export const getStartsCompetitorsColorScope = (days, mode) => {
    if (mode === 'ms') {
        return shareColorScope[days];
    } else if (mode === 'starts') {
        return absColorScope[days];
    }
    return leadershipColorScope[days];
};
